import { render, staticRenderFns } from "./revscorev2.vue?vue&type=template&id=2d2d3a32&scoped=true"
import script from "./revscorev2.vue?vue&type=script&lang=js"
export * from "./revscorev2.vue?vue&type=script&lang=js"
import style0 from "./revscorev2.vue?vue&type=style&index=0&id=2d2d3a32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2d3a32",
  null
  
)

export default component.exports